import { Card, Row, Col } from "antd";
import { Link } from "react-router-dom";
import { groupedTools } from "../data/toolsData";
import { useTranslation } from "react-i18next";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { localizedPath } from "../utils/paths";

const Help = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-indigo-50 to-white">
      <Header />
      <div className="max-w-6xl mx-auto px-4 py-12 text-gray-800">

        {/* Video Section */}
        <section className="mb-16">
          <h2 className="text-4xl font-bold text-indigo-700 mb-6">
            {t("why_need_quto_title")}
          </h2>
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-indigo-100">
            <div className="relative pb-[56.25%] h-0"> {/* 16:9 aspect ratio */}
              <video
                className="absolute top-0 left-0 w-full h-full"
                controls
                poster="https://quto-dev.s3.us-east-1.amazonaws.com/public/why-i-need-quto-dev-thumbnail.jpeg"
              >
                <source src="https://quto-dev.s3.us-east-1.amazonaws.com/public/why-i-need-quto-dev.mp4" type="video/mp4" />
                <p className="absolute inset-0 flex items-center justify-center text-lg">
                  {t("video_not_supported")}
                </p>
              </video>
            </div>
            <div className="p-6">
              <h3 className="text-xl font-semibold text-indigo-800 mb-3">
                {t("unlock_superpowers_title")}
              </h3>
              <p className="text-gray-700">
                {t("unlock_superpowers_description")}
              </p>
            </div>
          </div>
        </section>

        {/* About Section */}
        <section className="mb-16">
          <h2 className="text-4xl font-bold text-indigo-700 mb-4">
            {t("about_quto_title")}
          </h2>
          <p className="text-lg leading-relaxed mb-3">{t("about_quto_line1")}</p>
          <p className="text-lg leading-relaxed">{t("about_quto_line2")}</p>
        </section>

        {/* Pricing Section */}
        <section className="mb-16">
          <h2 className="text-4xl font-bold text-indigo-700 mb-4">
            {t("pricing_title")}
          </h2>
          <p className="text-lg leading-relaxed mb-3">
            {t("pricing_line1")}
          </p>
          <p className="text-lg leading-relaxed">
            {t("pricing_line2")}
          </p>
        </section>

        {/* Tools */}
        {Object.entries(groupedTools).map(([category, tools]) => (
          <div key={category} className="mb-14">
            <h3 className="text-2xl font-semibold text-indigo-700 mb-4 border-b border-indigo-200 pb-2">
              {t(`category_${category.toLowerCase()}`)}
            </h3>
            <div className="grid gap-6 md:grid-cols-2">
              {tools.map((tool) => (
                <Card
                  key={tool.name}
                  className="shadow-md rounded-lg transition-all hover:shadow-xl relative"
                  bodyStyle={{ padding: "20px" }}
                >
                  <Link to={localizedPath(i18n.language, tool.path)} className="block mb-2">
                    <h4 className="text-xl font-semibold text-indigo-600 hover:underline">
                      {t(tool.nameKey || tool.name)}
                    </h4>
                  </Link>
                  {tool.isPaid && (
                    <span className="absolute top-4 right-4 bg-red-100 text-red-600 text-xs font-semibold px-2 py-0.5 rounded-full shadow-sm">
                      {t("paid_tool")}
                    </span>
                  )}
                  <p className="text-gray-700 text-sm mt-1">
                    {t(tool.descriptionKey || tool.description)}
                  </p>
                </Card>
              ))}
            </div>
          </div>
        ))}

        {/* Contact Us */}
        <section className="mt-20 pt-10 border-t border-gray-200">
          <h2 className="text-2xl font-bold text-indigo-700 mb-2">
            {t("contact_us_title")}
          </h2>
          <p className="text-base text-gray-700">{t("contact_us_description")}</p>
          <p className="text-indigo-600 font-medium mt-1">
            {t("contact_us_email")}
          </p>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Help;